
import RegisterTestComponent from "@/views/Hiv/RegisterTest/RegisterTestComponent";
export default RegisterTestComponent;
